import React from 'react';
import styled from '@emotion/styled';
import HudsonLogo from '../components/hudsonlogos-01.png';
import { RiFileWarningFill } from 'react-icons/ri';

export const TopBarStyles = styled.div`
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c0bcb4;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  height: 70px;
  @media (min-width: 768px) {
    padding: 0 40px;
  }
  @media (min-width: 1024px) {
    padding: 0 70px;
  }
  @media (min-width: 1700px) {
    padding: 0 230px;
  }
`;

const GlobalError = () => {
  return (
    <div>
      <TopBarStyles>
        <div style={{ cursor: 'pointer' }}>
          <img src={HudsonLogo} style={{ width: 150, height: 62 }} alt="" />
        </div>
      </TopBarStyles>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 100 }}>
        <div
          style={{ flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <RiFileWarningFill size={170} />
          <div style={{ justifyContent: 'center', display: 'flex', marginTop: 30 }}>
            Sorry, we are experiencing technical issues right now.
          </div>
          <div>
            Please reach out to us by email
            <a
              href="mailto:orders@hudsonsearch.com?subject=Internal server error&cc=sdavidowitz@hudsonsearch.com"
              style={{ marginLeft: 4, marginRight: 4 }}
            >
              orders@hudsonsearch.com
            </a>
            or by phone at 866-260-9308.
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalError;
